import { render, staticRenderFns } from "./IssueRemoveModal.vue?vue&type=template&id=684808b5&"
import script from "./IssueRemoveModal.vue?vue&type=script&lang=js&"
export * from "./IssueRemoveModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueRemoveModal.vue?vue&type=style&index=0&id=684808b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports